

function initProductCompanions() {
  console.log(document.querySelectorAll('.add-to-cart'))
  $('.add-to-cart').click(function(e) {
    e.preventDefault();
    
    var error = false;
    
    
    console.log("test");
    var $addToCartForm = $(this).closest('form');
    var $addToCartBtn = $addToCartForm.find('.add_to_cart');
    var $primaryProduct = $addToCartForm.find('[name="id"]').val();
    var monoGram = $addToCartForm.find('[name="properties[Monogram: Choose from 1, 2, OR 3 UPPERCASE LETTERS]"]').val();
    var $qtyValue = $('#quantity').val();
    var productsToAdd = [];
    var items = [];
    var handle;
    
    if( $addToCartForm.find('[name="properties[Monogram: Choose from 1, 2, OR 3 UPPERCASE LETTERS]"]').lenth > 0 && $addToCartForm.find('[name="properties[Monogram: Choose from 1, 2, OR 3 UPPERCASE LETTERS]"]').val() == "" ){
      error = true;
      $addToCartForm.find('[name="properties[Monogram: Choose from 1, 2, OR 3 UPPERCASE LETTERS]"]').addClass('validation-error');
    	
    }
    
    
    var mainProductData = {
      quantity: $qtyValue,
      id: $primaryProduct
    }
    if(typeof monoGram != "undefined" ){
        mainProductData = {
          quantity: $qtyValue,
          id: $primaryProduct,
          properties:{
            'Monogram':monoGram.toUpperCase()
          } 
        }
    }
       
    productsToAdd.push(mainProductData);
    
    $('.companion-product input[type="checkbox"]:checked').each(function() {
      handle = $(this).data('product'); 
      var comanionProd = {
        quantity: 1,
        id: handle
      }
      if($(this).closest('.companion-product').find('.monograme-product-text').length > 0){
        
        if($(this).closest('.companion-product').find('.monograme-product-text').val() == ""){
          error = true;
          $(this).closest('.companion-product').find('.monograme-product-text').addClass('validation-error');
        }
        comanionProd = {
          quantity: 1,
          id: handle,
          properties:{
            'Monogram':$(this).closest('.companion-product').find('.monograme-product-text').val().toUpperCase()
          } 
        }
      }
                                       
      productsToAdd.push(comanionProd);                                
    });
    
    
  
    
    if(!error){
        $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: productsToAdd },
      dataType: 'json', 
      beforeSend: function() {

      },
      success: function(itemData) {
        
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function() {
            new theme.CartDrawer();
            setTimeout(function() {
              $('.js-drawer-open-cart').trigger("click");
            }, 500)
          }
        });
      },
      error: function(XMLHttpRequest) {
        console.log(XMLHttpRequest);

        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();

        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
        $addToCartForm.after(warning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text("Add to cart").removeClass('zoomOut').addClass('zoomIn');
      }
    });
    }else{
      alert("Oops! Your monogram information is missing. Please enter up to 3 capital letters to add item to cart.");
    }

  
    
    return false;
  });
}

	